module.exports = __webpack_public_path__ + "static/img/nai69.f55dd4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nai69.png
// module id = YSp6
// module chunks = 0